import { useField } from "formik";
import React, { FC } from "react";
import { usePlacesWidget } from "react-google-autocomplete";
import { AddressOption } from "../constants/Address";

interface IAFAddressSelectorProps {
    placeholder: string;
    addressField: string;
    cityField: string;
    postcodeField: string;
    onAddressChanged: (address: any) => void;
}

interface IAddress {
    fullAddress: string;
    city: string;
    postcode: string;
}


const AFAddressSelector: FC<IAFAddressSelectorProps> = (props) => {
    const { placeholder, addressField, cityField, postcodeField, onAddressChanged } = props;
    const [addressProps,, addressHelpers] = useField(addressField);
    const [,, cityHelpers] = useField(cityField);
    const [,, postcodeHelpers] = useField(postcodeField);

    const placesApiKey = window.googlePlacesApiKey || "";

    const { ref: placesRef } = usePlacesWidget({
        apiKey: placesApiKey,
        onPlaceSelected: (place) => {
            const { address_components, formatted_address } = place;
            const city = address_components? address_components.find((i) => i.types.includes("locality")) : null;
            const postCode = address_components? address_components.find((i) =>
                i.types.includes("postal_code")
            ) : null;
            const stateAddress: IAddress = {
                fullAddress: formatted_address,
                city: city?.long_name || "",
                postcode: postCode?.long_name || ""
            };
            addressHelpers.setValue(stateAddress.fullAddress);
            cityHelpers.setValue(stateAddress.city);
            postcodeHelpers.setValue(stateAddress.postcode);
            const addressInfo = {};
            addressInfo[addressField] = stateAddress.fullAddress;
            addressInfo[cityField] = stateAddress.city;
            addressInfo[postcodeField] = stateAddress.postcode;
            onAddressChanged(addressInfo);
        },
        options: AddressOption
    });

    const handleInputChange = (value) => {
        // Clear address if input is empty
        if (!value || value == '') {
            addressHelpers.setValue('');
            cityHelpers.setValue('');
            postcodeHelpers.setValue('');
        }
    };

    return (
        <React.Fragment>
            <input
                {...addressProps}
                autoFocus={false}
                type="text"
			    onChange={(e) => {
                    addressProps.onChange(e);
				    handleInputChange(e.target.value);
                }}
			    placeholder={placeholder}
                ref={(el) => {
                    if (el && el instanceof HTMLInputElement) {
                        (placesRef as React.MutableRefObject<HTMLInputElement | null>).current = el;
                    }
                }}
			    autoComplete="one-time-code"
            />
        </React.Fragment>
    );
};

export default AFAddressSelector;
